var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal" } }, [
    _c("div", { staticClass: "modal-mask" }, [
      _c(
        "div",
        { staticClass: "modal-container" },
        [
          _c("div", { staticClass: "d-flex justify-content-end" }, [
            _c(
              "button",
              {
                staticClass: "btn",
                on: {
                  click: function($event) {
                    return _vm.$emit("close")
                  }
                }
              },
              [_vm._v("❌")]
            )
          ]),
          _c(
            "form-wizard",
            {
              attrs: {
                color: "#678DD7",
                "back-button-text": _vm.T.wordsBack,
                "finish-button-text": _vm.T.wordsConfirm,
                "next-button-text": _vm.T.wordsNext,
                subtitle: _vm.T.wizardDescription,
                title: _vm.T.wizardTitle
              },
              on: { "on-complete": _vm.searchProblems }
            },
            [
              _c(
                "tab-content",
                { attrs: { title: _vm.T.wizardStepOne } },
                [
                  _c("toggle-button", {
                    attrs: {
                      color: { checked: "#678DD7", unchecked: "#343a40" },
                      "font-size": 12,
                      height: 35,
                      labels: {
                        checked: "" + _vm.T.wordsKarel,
                        unchecked: "" + _vm.T.wordsAnyLanguage
                      },
                      value: _vm.karel,
                      width: 160
                    },
                    model: {
                      value: _vm.karel,
                      callback: function($$v) {
                        _vm.karel = $$v
                      },
                      expression: "karel"
                    }
                  }),
                  _c("tags-input", {
                    attrs: {
                      "element-id": "tags",
                      "existing-tags": _vm.tagObjects,
                      "only-existing-tags": true,
                      placeholder: _vm.T.wordsAddTag,
                      typeahead: true
                    },
                    model: {
                      value: _vm.selectedTags,
                      callback: function($$v) {
                        _vm.selectedTags = $$v
                      },
                      expression: "selectedTags"
                    }
                  })
                ],
                1
              ),
              _c(
                "tab-content",
                { attrs: { title: _vm.T.wizardStepTwo } },
                [
                  _c("vue-slider", {
                    attrs: {
                      tooltip: "none",
                      adsorb: true,
                      "dot-size": 18,
                      "enable-cross": false,
                      included: true,
                      marks: _vm.SLIDER_MARKS,
                      max: 4,
                      min: 0
                    },
                    model: {
                      value: _vm.difficultyRange,
                      callback: function($$v) {
                        _vm.difficultyRange = $$v
                      },
                      expression: "difficultyRange"
                    }
                  })
                ],
                1
              ),
              _c("tab-content", { attrs: { title: _vm.T.wizardStepThree } }, [
                _c(
                  "div",
                  { staticClass: "tab-select" },
                  _vm._l(_vm.PRIORITIES, function(priority) {
                    return _c(
                      "label",
                      {
                        staticClass: "tab-select-el",
                        class: {
                          "tab-select-el-active":
                            priority.type === _vm.selectedPriority
                        }
                      },
                      [
                        _vm._v(_vm._s(priority.text) + " "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectedPriority,
                              expression: "selectedPriority"
                            }
                          ],
                          staticClass: "hidden-radio",
                          attrs: { name: "priority", type: "radio" },
                          domProps: {
                            value: priority.type,
                            checked: _vm._q(_vm.selectedPriority, priority.type)
                          },
                          on: {
                            change: function($event) {
                              _vm.selectedPriority = priority.type
                            }
                          }
                        })
                      ]
                    )
                  }),
                  0
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }